// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"styles_flexContainer__3-BHu"};